const DAY_MS = 24 * 60 * 60 * 1000;

// A login lasts 7 days. Renewing once fewer than 6 days are left means about one renewal a day
// while a tutor has the app open (POST /auth/renew; the server caps renewals at 30 days).
export const RENEW_WHEN_LEFT_MS = 6 * DAY_MS;
export const RENEW_CHECK_MS = 30 * 60 * 1000;

/** The login's expiry in ms, read from the token's own payload, or null when it cannot be read. */
export function tokenExpiresAt(token) {
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(atob(payload));
    return typeof exp === 'number' ? exp * 1000 : null;
  } catch {
    return null;
  }
}

/** True for a still-valid login that is old enough to swap for a fresh one. */
export function shouldRenew(token, now) {
  const expiresAt = token ? tokenExpiresAt(token) : null;
  return expiresAt !== null && expiresAt > now && expiresAt - now < RENEW_WHEN_LEFT_MS;
}
